<div class="cookie-banner" [class.cookie-banner--auth-page]="isAuthPage()" *ngIf="visible()">
  <div class="cookie-banner__content">
    <p class="cookie-banner__text">
      {{ 'cookieConsent.banner.text.part1' | translate }}
      <a routerLink="/privacy-policy" target="_blank" (click)="$event.stopPropagation()" class="cookie-banner__link">{{ 'cookieConsent.banner.text.privacyPolicyLink' | translate }}</a>.
    </p>
    <div class="cookie-banner__actions">
      <app-x-button [size]="'28'" [style]="'outlined'" (click)="onReject()">
        {{'reject' | translate}}
      </app-x-button>
      <app-x-button [size]="'28'" [style]="'filled-black'" (click)="onAccept()">
        {{'continue' | translate}}
      </app-x-button>
    </div>
  </div>
</div> 